import {getRequest, getRequestFile, postRequest} from "../fetchWrapper";

/**
 * Récupération de la liste des événements pour un défunt.
 *
 * @param string $token Jeton d'authentification.
 * @param int $id Identifiant du défunt.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEventList = (token, id) => {
    const url = `/api-v1/deceased/${id}/event/list`;
    return getRequest(url, token)
};


/**
 * Lecture de la liste des événements pour un défunt détaillés.
 *
 * @param string $token Jeton d'authentification.
 * @param int $id Identifiant du défunt.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEventListInfos = (token, id) => {
    const url = `/api-v1/deceased/${id}/events/infos`;
    return getRequest(url, token)
}

/**
 * Lecture de la liste des événements.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEventTypeList = (token) => {
    const url = `/api-v1/event/list`;
    return getRequest(url, token)
};

/**
 * Lecture des informations d'un événement.
 *
 * @param string $token Jeton d'authentification.
 * @param int $id Identifiant de l'événement.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEventInfos = (token, id, type) => {
    const url = `/api-v1/event/${type}/${id}/infos`;
    return getRequest(url, token)
}

/**
 * Lecture de la liste des sous-types d'événements.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEventSubList = (token, event) => {
    const url = `/api-v1/event/sub/${event}/list`;
    return getRequest(url, token)
};

/**
 * Lecture de la liste des lieux d'événements.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEventPlaceList = (token, event) => {
    const url = `/api-v1/event/place/${event}/list`;
    return getRequest(url, token)
};

/**
 * Mise à jour d'un événement.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateEventInfos = (token, body) => {
    const url = `/api-v1/event/update`;
    return postRequest(url, body, token)
};

/**
 * Lecture des informations d'un événement.
 *
 * @param string $token Jeton d'authentification.
 * @param int $deceased Identifiant du défunt.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEventAddedInfos = (token, deceased) => {
    const url = `/api-v1/event/${deceased}/event_infos`;
    return getRequest(url, token)
};

/**
 * Mise à jour des informations complémentaires d'un événement.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateEventAddedInfos = (token, body) => {
    const url = `/api-v1/event/added_infos/update`;
    return postRequest(url, body, token)
};

/**
 * Mise à jour du message personnel.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateEventThoutght = (token, body) => {
    const url = `/api-v1/event/thoughts/update`;
    return postRequest(url, body, token)
};

/**
 * Suppression d'un événement.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const deleteEventFromDb = (token, body) => {
    const url = `/api-v1/event/delete`;
    return postRequest(url, body, token)
};

/**
 * Télécharge le mémo des obsèques au format PDF.
 *
 * @param string $token Jeton d'authentification.
 * @param int $deceased Identifiant du défunt.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const downloadCadMemo = (token, id) => {
    const url = `/api-v1/cad/express/${id}/memo`;
    return getRequestFile(url, token)
}

/**
 * Télécharge le mémo des obsèques au format PDF.
 *
 * @param string $token Jeton d'authentification.
 * @param int $deceased Identifiant du défunt.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const downloadFuneralMemo = (token, id) => {
    const url = `/api-v1/event/memo/${id}/view`;
    return getRequestFile(url, token)
}